import { TAdFoxBannerTemplate } from '@cian/adfox-component';
import { AdFoxTemplates } from '@cian/adfox-templates';
import * as React from 'react';

export const OwnTemplates: React.FC<TAdFoxBannerTemplate> = props => {
  return <AdFoxTemplates deviceType="desktop" {...props} />;
};
